import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
/* import App from './App';
import { ProductProvider } from './context/ProductContext'; */
/* import App from './makanapp/App';
import { ProductProvider } from './makanapp/context/ProductContext'; */
import App from './App';
import { ProductProvider } from './main/context/ProductContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProductProvider>
    <App />
    </ProductProvider>
  </React.StrictMode>
);


